import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MAIL_CLASSIFICATION_STATUS, OUTGOING_MAIL_STATUSES } from "src/utils/constants/constants";
import { Props, OutgoingMailCombinedStatusOptionValue, OutgoingMailCombinedStatusQuickFilter } from "./interfaces";
import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const OutgoingMailCombinedStatusQuickfilter = <Q extends OutgoingMailCombinedStatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.outgoing_mail_status"; // tRP - translation root path

  const options: QuickFilterOption<OutgoingMailCombinedStatusOptionValue>[] = [
    {
      name: t("common_words.all"),
      value: {
        statusIds: [],
      },
    },
    {
      name: t(`${tRP}.requiring_classification`),
      value: {
        statusIds: [MAIL_CLASSIFICATION_STATUS.ToBeClassified.id],
      },
    },
    {
      name: t(`${tRP}.requiring_posting`),
      value: {
        statusIds: [OUTGOING_MAIL_STATUSES.Pending.id],
      },
    },
  ];

  const getMultipleSelectionLabel = useCallback(
    (value: Q["outgoingMailCombinedStatus"][keyof Q["outgoingMailCombinedStatus"]][] | string[][]): string | null => {
      const flattenedValues = value.flat(2);

      if (
        flattenedValues.includes(OUTGOING_MAIL_STATUSES.Pending.id) &&
        flattenedValues.includes(MAIL_CLASSIFICATION_STATUS.ToBeClassified.id)
      ) {
        return t(`${tRP}.requiring_actions`);
      } else return null;
    },
    []
  );

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="outgoingMailCombinedStatus"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      isMultiSelect
      multiSelectField="statusIds"
      getMultipleSelectionLabel={getMultipleSelectionLabel}
    />
  );
};
